<div class="divOC">
  <div class="divHome">
    <div style="padding-bottom: 2rem;">
     <h1>Orden de compra</h1>
  </div>

  <form [formGroup]="formOC">
    <div  style="display: flex; justify-content: right;">

     <!--  <mat-form-field class="example-full-width">
        <mat-label>CODIGO</mat-label>
          <input matInput placeholder="Placeholder" formControlName="codigoOC" name="codigoOC" >
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="example-full-width">
        <mat-label>FECHA</mat-label>
          <input matInput placeholder="Placeholder" formControlName="fecha" name="fecha" >
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" (click)="openDialogProvider()">PROVEEDOR</button>
    <br>
    <div  style="display: flex; justify-content: space-between; margin-top: 10px;">


      <mat-form-field appearance="outline" class="example-full-width" style="width: 40%; ">
        <mat-label>NOMBRE</mat-label>
          <input matInput placeholder="Placeholder" formControlName="nombreProvider" name="nombreProvider" style=" color: black !important;">
      </mat-form-field>
      <mat-form-field appearance="outline" class="example-full-width" style="width: 20%; ">
        <mat-label>RUC</mat-label>
          <input matInput placeholder="Placeholder" formControlName="ruc" name="ruc" style=" color: black !important;">
      </mat-form-field>
      <mat-form-field appearance="outline" class="example-full-width" style="width: 30%; ">
        <mat-label>DIRECCION</mat-label>
          <input matInput placeholder="Placeholder" formControlName="direccion" name="direccion" style=" color: black !important;">
      </mat-form-field>
    </div>

    <div  style="display: flex; justify-content: space-between;">
      <mat-form-field appearance="outline" class="example-full-width">
        <mat-label>CENTRO DE COSTO</mat-label>
        <mat-select formControlName="centroCosto" >
          <mat-option *ngFor="let objCC of lstCC" [value]="objCC">
            {{ objCC.cc +" - "+ objCC.descripcion }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="example-full-width">
        <mat-label>AREA</mat-label>
        <mat-select formControlName="area" >
          <mat-option *ngFor="let objArea of lstArea" [value]="objArea">
            {{ objArea }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="example-full-width">
        <mat-label>MONEDA</mat-label>
        <mat-select formControlName="moneda" >
          <mat-option *ngFor="let objM of lstMoneda" [value]="objM">
            {{ objM }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <mat-form-field class="example-full-width">
        <mat-label>INAFECTO</mat-label>
        <mat-select formControlName="inafecto" >
          <mat-option *ngFor="let obj of lstInafecto" [value]="obj">
            {{ obj }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
     <!--  <mat-form-field class="example-full-width">
        <mat-label>IGV</mat-label>
        <mat-select formControlName="igvValue" >
          <mat-option *ngFor="let obj of lstIgv" [value]="obj">
            {{ obj }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    </div>
    <div  style="display: flex; justify-content: space-around; ">
      <mat-form-field appearance="outline" class="example-full-width" style="width: 100%">
        <mat-label>Observacion/es</mat-label>
          <input matInput placeholder="Placeholder" formControlName="observacion" name="observacion" >
      </mat-form-field>
    </div>
    <br/>
    <button mat-raised-button class="buttonPrimary" (click)="openDialogItem()" >Agregar Item</button>
    <br/>
    <ng-container *ngIf="estado">
      <div  style="margin-top: 3%" class="example-container mat-elevation-z8">
        <mat-table [dataSource]="DataSource"  >

          <ng-container matColumnDef="item">
            <mat-header-cell  *matHeaderCellDef>item</mat-header-cell>
            <mat-cell  *matCellDef="let element">{{ element?.item }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="descripcion">
            <mat-header-cell  *matHeaderCellDef>descripcion</mat-header-cell>
            <mat-cell  *matCellDef="let element">{{ element?.descripcion }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="cantidad">
            <mat-header-cell  *matHeaderCellDef>cantidad</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.cantidad }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="precioUnidad">
            <mat-header-cell  *matHeaderCellDef>precioUnidad</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.precioUnidad }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="inafecto">
            <mat-header-cell  *matHeaderCellDef>Inafecto</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.inafecto }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="igv">
            <mat-header-cell  *matHeaderCellDef>igv</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.igv }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="monto">
            <mat-header-cell  *matHeaderCellDef>monto</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.monto }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>Eliminar</th>
            <td mat-cell *matCellDef="let i = index">
              <button mat-icon-button class="removeCart" (click)="removeItem(i)" >
                <mat-icon>close</mat-icon>
              </button>
            </td>
        </ng-container>


          <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row   *matRowDef="let row; columns: displayedColumns"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </ng-container>
    <br>
    <div  style="display: flex; justify-content: right;" *ngIf="estadoItems">
      <mat-form-field class="example-full-width">
        <mat-label>SUBTOTAL</mat-label>
          <input matInput placeholder="Placeholder" formControlName="subTotal" name="subTotal" >
      </mat-form-field>
    </div>

    <div  style="display: flex; justify-content: right;" *ngIf="estadoItems">
      <mat-form-field class="example-full-width">
        <mat-label>I.G.V.</mat-label>
          <input matInput placeholder="Placeholder" formControlName="igv" name="igv" >
      </mat-form-field>
    </div>

    <div  style="display: flex; justify-content: right;" *ngIf="estadoItems">
      <mat-form-field class="example-full-width">
        <mat-label>TOTAL</mat-label>
          <input matInput placeholder="Placeholder" formControlName="total" name="total" >
      </mat-form-field>
    </div>

  </form>
  <div style="margin-top: 0.2rem;display: flex;justify-content: center">
    <button mat-raised-button class="buttonPrimary" (click)="createOC()" >Enviar OC </button>
  </div>
</div>
